export function enumToArray<T>(enumeration: T): Array<T[keyof T]> {
  return Object.keys(enumeration)
    .filter((key) => Number.isNaN(Number(key)))
    .map((key) => enumeration[key])
    .filter((val): val is T[keyof T] => typeof val === 'number' || typeof val === 'string')
}
